import type { FC } from 'react';
import { memo } from 'react';
import FilterIcon from '@public/assets/common/icons/filter.svg';
import type { FilterMainTitleProps } from './FilterMainTitle.types';
import styles from './FilterMainTitle.module.scss';
const BaseFilterMainTitle: FC<FilterMainTitleProps> = ({
  classes,
  selectedNumber,
  isMobile,
  title
}) => {
  return <div className={styles.root} data-sentry-component="BaseFilterMainTitle" data-sentry-source-file="FilterMainTitle.tsx">
      <FilterIcon className={styles.icon} width={20} height={20} data-sentry-element="FilterIcon" data-sentry-source-file="FilterMainTitle.tsx" />
      {(isMobile && !selectedNumber || !isMobile) && <span className={cn(styles.title, classes?.title)}>{title}</span>}
      {!!selectedNumber && <div className={styles.badge}>{selectedNumber}</div>}
    </div>;
};
export const FilterMainTitle = memo(BaseFilterMainTitle);
FilterMainTitle.displayName = 'FilterMainTitle';